(() => {
  if (customElements.get('kd-tencel-benefits')) return;
  customElements.define('kd-tencel-benefits', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.track = this.querySelector('[data-cards]');
      this.cards = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      const controls = this.querySelector('[data-controls]');
      if (!controls) return;
      controls.hidden = false;
      this.index = 0;
      controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        const index = button.dataset.slide != null ? Number(button.dataset.slide) : this.index + Number(button.dataset.step);
        this.go(index);
      }, {signal});
      this.track.addEventListener('scroll', () => {
        const left = this.track.getBoundingClientRect().left;
        let closest = 0;
        this.cards.forEach((card, index) => {
          if (Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[closest].getBoundingClientRect().left - left)) closest = index;
        });
        this.index = closest;
        this.dots.forEach((dot, index) => {
          if (index === closest) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }, {signal, passive: true});
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (index >= 0) this.go(index);
      }, {signal});
      this.resize = new ResizeObserver(() => this.go(this.index, false));
      this.resize.observe(this.track);
    }
    go(index, animate = true) {
      if (!matchMedia('(max-width: 749px)').matches || !this.cards.length) return;
      this.index = (index + this.cards.length) % this.cards.length;
      const card = this.cards[this.index];
      const offset = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({
        left: this.track.scrollLeft + offset,
        behavior: animate ? 'smooth' : 'auto'
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      this.controller = null;
    }
  });
})();
